import { useState } from "react";
import LeaseFilter from "../components/Filter";
import styles from "./leases.module.css";
import LeaseList from "./component/LeaseList";
import LeaseGraph from "./component/LeaseGraph";

const LeaseListView = ({ handleView, filterData, setFilterData, isGridView }) => {
  const [, setPage] = useState(0);
  const [selectedIds, setSelectedIds] = useState(null);

  return (<div className={`${styles.BodyCon}`}>
    <div className={`${styles.mainCardDiv}`}>
      <div className={`${styles.mainCard}`}>
        <div className="control-pane">
          <LeaseFilter
            isGridView={isGridView}
            handleView={handleView.bind(this)}
            filterData={filterData}
            setFilterData={setFilterData.bind(this)}
            setPage={setPage.bind(0)}
          />

          <div className={`${styles.IncomeListingBody}`}>
            <div className={`${styles.IncomeListSec}`}>
              <LeaseList
                filterData={filterData}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
              />
            </div>
            <div className={`${styles.IncomeGraphSec}`}>
              <LeaseGraph filterData={filterData} selectedIds={selectedIds} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>);
};

export default LeaseListView;